import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { SearchChatListRes } from "../../types/SearchChatListType";

export const useSearchChatList = (searchText: string) => {
  return useQuery<SearchChatListRes, Error>(
    ["chat/search-chat", searchText],
    async () => {
      const response = await axiosInstance.post<SearchChatListRes>(
        "chat/search-chat",
        { searchText }
      );

      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: !!searchText, // prevents API call when input is empty
    }
  );
};
